'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/millisecondsFromNow.js
// module id = 570
// module chunks = 0